import { render, staticRenderFns } from "./EmailWindow.vue?vue&type=template&id=44f387ad&"
import script from "./EmailWindow.vue?vue&type=script&lang=js&"
export * from "./EmailWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports